module.exports = __webpack_public_path__ + "static/media/day21.workshop.247c2bc7.md";